export const REVIEW_PROBLEM_TABS = [
	{ key: "all", label: "All Issues" },
	{ key: "warning", label: "Warnings" },
	{ key: "invalid", label: "Invalid" },
	{ key: "previously_imported", label: "Previously Imported" },
	{ key: "mapping_required", label: "Mapping Required" },
];

export const REVIEW_SUMMARY_CARDS = [
	{ countKey: "totalRows", label: "Total Rows", tone: "neutral" },
	{ countKey: "readyToImport", label: "Ready to Import", tone: "success" },
	{ countKey: "warnings", label: "Warnings", tone: "warning" },
	{ countKey: "invalidRows", label: "Invalid Rows", tone: "danger" },
	{ countKey: "previouslyImported", label: "Previously Imported", tone: "muted" },
	{ countKey: "mappingRequired", label: "Mapping Required", tone: "danger" },
];

export const VALIDATION_CHECK_ITEMS = [
	{ key: "csvStructureValid", label: "CSV structure valid" },
	{ key: "requiredFieldsPresent", label: "Required fields present" },
	{ key: "datesValid", label: "Dates valid" },
	{ key: "timesValid", label: "Times valid" },
	{ key: "ehrVisitIdsUnique", label: "EHR Visit IDs unique" },
	{ key: "clientProviderMappingsAvailable", label: "Client and provider mappings available" },
];

export const formatReviewUploadTime = (value) => {
	if (!value) return "—";
	const date = value instanceof Date ? value : new Date(value);
	if (Number.isNaN(date.getTime())) return "—";

	const now = new Date();
	const isToday =
		date.getFullYear() === now.getFullYear() &&
		date.getMonth() === now.getMonth() &&
		date.getDate() === now.getDate();

	const timePart = date.toLocaleTimeString("en-US", {
		hour: "numeric",
		minute: "2-digit",
	});

	return isToday ? `Today, ${timePart}` : `${date.toLocaleDateString("en-US")}, ${timePart}`;
};

export const filterProblemRows = (problemRows, activeTab) => {
	if (!Array.isArray(problemRows)) return [];
	if (activeTab === "all") return problemRows;
	return problemRows.filter((row) => row.category === activeTab);
};

export const formatProblemCategory = (category) => {
	switch (category) {
		case "warning":
			return "Warning";
		case "invalid":
			return "Invalid";
		case "previously_imported":
			return "Previously Imported";
		case "mapping_required":
			return "Mapping Required";
		default:
			return category;
	}
};

export const downloadImportErrorReport = (problemRows, fileName = "ehr-import-error-report.csv") => {
	if (!Array.isArray(problemRows) || !problemRows.length) return;

	const header = ["Row", "Category", "EHR Visit ID", "Client", "Provider", "Date of Service", "Issues"];
	const escapeCsv = (value) => `"${String(value ?? "").replace(/"/g, '""')}"`;
	const lines = [
		header.join(","),
		...problemRows.map((row) =>
			[
				row.csvRowNumber,
				formatProblemCategory(row.category),
				row.ehrVisitId,
				row.clientName,
				row.providerName,
				row.dateOfService || "",
				(row.issues || []).join("; "),
			]
				.map(escapeCsv)
				.join(","),
		),
	];

	const blob = new Blob([lines.join("\n")], { type: "text/csv;charset=utf-8;" });
	const url = URL.createObjectURL(blob);
	const link = document.createElement("a");
	link.href = url;
	link.download = fileName.endsWith(".csv") ? fileName : `${fileName.replace(/\.csv$/i, "")}-errors.csv`;
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
	URL.revokeObjectURL(url);
};
